/* eslint-disable react/prop-types */

/* eslint-disable prettier/prettier */
import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.65 2H10.7V4H13.65V2Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.15 9.15C15.05 9.05 14.95 9 14.85 8.95C14.5 8.7 14.05 8.55 13.6 8.5C13.6 8.5 13.55 8.5 13.55 8.45V6H13.7C14.15 6 14.5 5.65 14.5 5.25C14.5 4.85 14.15 4.5 13.7 4.5H10.55C10.1 4.5 9.75 4.85 9.75 5.25C9.75 5.65 10.1 6 10.55 6H10.7V8.5C10.7 8.5 10.7 8.55 10.65 8.55C10.2 8.6 9.8 8.75 9.4 9C9.3 9.05 9.2 9.1 9.1 9.2C8.45 9.7 8 10.5 8 11.4V21.3C8 21.7 8.35 22 8.75 22H15.6C16 22 16.35 21.7 16.35 21.3V11.4C16.3 10.5 15.85 9.7 15.15 9.15ZM15.25 18.45C15.25 18.5 15.25 18.5 15.25 18.45C15.2 18.5 15.2 18.5 15.25 18.45L9.1 18.5C9.1 18.5 9.05 18.5 9.05 18.45V12.55C9.05 12.55 9.05 12.5 9.1 12.5H15.25C15.25 12.5 15.3 12.5 15.3 12.55V18.45H15.25Z",
  fill: "currentColor"
})), 'CategoryBA');